// src/components/CookieBanner.js

import React from 'react';
import CookieConsent from "react-cookie-consent";

function CookieBanner() {
  const handleAccept = async () => {
    try {
      const ipResponse = await fetch('https://api.ipify.org?format=json');
      const ipData = await ipResponse.json();
      
      const userAgent = navigator.userAgent;
      const timestamp = new Date().toISOString();

      const payload = {
        access_key: "YOUR_ACCESS_KEY_HERE", // Replace with your Web3Forms Access Key
        subject: "New Cookie & IP Consent Log",
        from_name: "Consent System",
        message: "A user has accepted the cookie policy.",
        ip_address: ipData.ip,
        browser_data: userAgent,
        timestamp: timestamp
      };

      await fetch("https://api.web3forms.com/submit", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify(payload)
      });

    } catch (error) {
      console.error("Consent logging failed:", error);
    }
  };

  return (
    <CookieConsent
      location="bottom"
      buttonText="Accept All"
      declineButtonText="Decline"
      enableDeclineButton
      onAccept={handleAccept}
      cookieName="naprev_user_consent"
      style={{ 
        background: "#001524", 
        alignItems: "center", 
        padding: "10px 20px", 
        zIndex: 9999,
        boxSizing: "border-box", // Prevents extending beyond the screen
        width: "100%",
        minHeight: "50px"
      }}
      contentStyle={{
        margin: "0",
        flex: "1 1 auto"
      }}
      buttonWrapperClasses="cookie-buttons"
      buttonStyle={{ 
        backgroundColor: "#E1261C", 
        color: "#FFFFFF", 
        fontSize: "13px", 
        fontWeight: "bold", 
        borderRadius: "4px",
        padding: "8px 16px",
        margin: "5px 10px",
        cursor: "pointer"
      }}
      declineButtonStyle={{ 
        backgroundColor: "transparent", 
        color: "#D1D5DB", 
        fontSize: "13px",
        border: "1px solid #D1D5DB",
        borderRadius: "4px",
        padding: "7px 15px",
        margin: "5px 0",
        cursor: "pointer"
      }}
      expires={365}
    >
      <span style={{ fontSize: "13px", color: "#F9FAFB" }}>
        We use cookies to improve your experience and analyze traffic. See our <a href="/privacy-policy" style={{ color: "#E1261C", textDecoration: "none" }}>Privacy Policy</a>.
      </span>
    </CookieConsent>
  );
}

export default CookieBanner;